import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { useAdvanceTableContext } from 'providers/advanceTableProvider';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

const AdvanceTable = ({
  headerClassName,
  bodyClassName,
  rowClassName,
  tableProps,
  getRowProps
}) => {
  const table = useAdvanceTableContext();
  const { getRowModel, getFlatHeaders } = table;

  return (
    <div className="table-responsive scrollbar">
      <Table {...tableProps}>
        <thead className={headerClassName}>
          <tr>
            {getFlatHeaders().map(header => (
              <th
                key={header.id}
                {...header.column.columnDef.meta?.headerProps}
                className={classNames(
                  'fs-10 text-black',
                  header.column.columnDef.meta?.headerProps?.className,
                  {
                    sort: header.column.getCanSort(),
                    desc: header.column.getIsSorted() === 'desc',
                    asc: header.column.getIsSorted() === 'asc'
                  }
                )}
                onClick={header.column.getToggleSortingHandler()}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={bodyClassName}>
          {getRowModel().rows.map(row => {
            const props = getRowProps ? getRowProps(row) : {};
            const rowClass =
              typeof rowClassName === 'function'
                ? rowClassName(row)
                : rowClassName;

            return (
              <tr key={row.id} className={rowClass} {...props}>
                {row.getVisibleCells().map(cell => (
                  <td key={cell.id} {...cell.column.columnDef.meta?.cellProps}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

AdvanceTable.propTypes = {
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  tableProps: PropTypes.object,
  getRowProps: PropTypes.func
};

export default AdvanceTable;
